module.exports = __webpack_public_path__ + "img/PAN-PRI-PRD-PRS-PHBCS.5218e219.png";